import { Network } from "../../utils/helpers";
import homestead from "./homestead.json";

const config = {
  [Network.MAINNET]: homestead,
};

export default config;
